(() => {
  const scrollStorageKey = 'pino:section-scroll';

  const pagePath = (url) => `${url.pathname}${url.search}`;

  const scrollToSection = (targetId) => {
    const target = document.getElementById(targetId);
    if (!target) return false;

    const shortenServicesJourney = targetId === 'pino-services' && window.matchMedia('(max-width: 749px)').matches;
    if (shortenServicesJourney) {
      const allItems = document.querySelector('[id*="pino_all_items"]');
      const targetTop = target.getBoundingClientRect().top + window.scrollY;
      const shortStart = allItems
        ? allItems.getBoundingClientRect().bottom + window.scrollY
        : Math.max(0, targetTop - window.innerHeight * 0.8);

      if (Math.abs(window.scrollY - targetTop) > window.innerHeight * 1.25) {
        window.scrollTo({ top: Math.min(shortStart, targetTop), behavior: 'auto' });
      }
    }

    window.requestAnimationFrame(() => {
      target.scrollIntoView({ behavior: 'smooth', block: 'start' });
    });
    return true;
  };

  const rememberSection = (path, target) => {
    try {
      sessionStorage.setItem(scrollStorageKey, JSON.stringify({ path, target, expires: Date.now() + 30000 }));
    } catch (_) {}
  };

  const restoreSection = () => {
    let pending;
    try {
      pending = JSON.parse(sessionStorage.getItem(scrollStorageKey) || 'null');
    } catch (_) {
      pending = null;
    }

    if (!pending || pending.expires < Date.now() || pending.path !== pagePath(window.location)) return;
    try { sessionStorage.removeItem(scrollStorageKey); } catch (_) {}
    window.setTimeout(() => scrollToSection(pending.target), 80);
  };

  const restoreRentalContext = () => {
    let context;
    try {
      context = JSON.parse(sessionStorage.getItem('pino:rental-context') || 'null');
    } catch (_) {
      context = null;
    }
    if (!context || context.expires < Date.now()) return;

    const piecesField = document.querySelector('[name="contact[Pieces or style]"]');
    if (!piecesField || piecesField.value) return;
    piecesField.value = context.productUrl ? `${context.product} — ${context.productUrl}` : context.product;
    try { sessionStorage.removeItem('pino:rental-context'); } catch (_) {}
  };

  document.addEventListener('click', (event) => {
    const link = event.target.closest('a[href]');
    if (!link) return;

    const sourcingProduct = link.dataset.pinoSourcingProduct || '';
    const sourcingProductUrl = link.dataset.pinoSourcingProductUrl || '';
    if (sourcingProduct || sourcingProductUrl) {
      try {
        sessionStorage.setItem('pino:sourcing-context', JSON.stringify({
          product: sourcingProduct,
          productUrl: sourcingProductUrl,
          expires: Date.now() + 1800000
        }));
      } catch (_) {}
    }

    const rentalProduct = link.dataset.pinoRentalProduct || '';
    const rentalProductUrl = link.dataset.pinoRentalProductUrl || '';
    if (rentalProduct || rentalProductUrl) {
      try {
        sessionStorage.setItem('pino:rental-context', JSON.stringify({
          product: rentalProduct,
          productUrl: rentalProductUrl,
          expires: Date.now() + 1800000
        }));
      } catch (_) {}
    }

    const targetId = link.dataset.pinoScrollTarget;
    if (!targetId || event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;

    const destination = new URL(link.href, window.location.href);
    if (destination.origin !== window.location.origin) return;

    const destinationPath = pagePath(destination);
    if (destinationPath === pagePath(window.location)) {
      if (scrollToSection(targetId)) event.preventDefault();
      return;
    }

    rememberSection(destinationPath, targetId);
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => {
      restoreRentalContext();
      restoreSection();
    }, { once: true });
  } else {
    restoreRentalContext();
    restoreSection();
  }
})();
